<template>
<div>
    <div class="chartFilter">
        <select class="country_select toUpper" v-if="countryFlag" name="country">
            <option :value="countryList.id">{{countryList.displayName}}</option>
        </select>
        <select class="province_select toUpper" v-if="stateFlag" name="state" v-model="stateId" @change="provinceSelect($event)">
            <option value="">{{ $t("Filter.selectstate") }}</option>
            <option v-for="(items, idx) in stateList" :key="idx" :value="items.id">
                {{ items.name }}
            </option>
        </select>
        <select class="region_select toUpper" v-if="distFlag" name="district" v-model="distId" @change="districtChange($event)">
            <option value="">{{ $t("Filter.selectdistrict") }}</option>
            <option v-for="(items, idx) in districtList" :key="idx" :value="items.id">
                {{ items.name }}
            </option>
        </select>
        <!-- <select class="region_select toUpper" name="city" @change="cityChange($event)">
            <option selected="selected" value="">Select Facility</option>
            <option v-for="(items,idx) in facilityList" :key="idx" :value="items.id">{{items.name}}</option>
        </select> -->
        <!-- <select class="year_select">
            <option selected="selected">Start Year</option>
        </select>
        <select class="month_select">
            <option selected="selected">Select Month</option>
        </select>
        <select class="week_select">
            <option selected="selected">Select Week</option> -->
        <!-- </select> -->
        <button class="btn btn_apply" @click="triggerFilter()">Apply</button>
    </div>
    <div class="content-grid">
        <!-- Code for Nikshay -->
        <!-- <div class="flow_chart_holder " style="display: flex; justify-content: center">
        <div class="row pl-4 pr-4">
            <template v-for="(ind,idx) in flowChartObjNew">
                <div class="col-md-4" :key="idx">
                    <div class="flow-chart-base">
                        <span class="flow-chart-text">
                            % {{ind.indicatorname.replaceAll('LTBI', 'TBI')}}
                        </span>
                        <span class="flow-circle" id="contactSymTB"> {{Math.round(ind.indicatorvalue * 10) / 10}}%</span>
                        <i v-if="idx != 10" class="fa fa-arrow-right flow-circle-arrow"></i>
                    </div>
                </div>
            </template>
        </div>
        </div> -->
        <!-- Code for Nikshay end -->

        <div class="row align-items-stretch no-gutters">
            <div class="col-lg-12">
                <div v-for="(value, propertyName) in masterList" :key="propertyName">
                  <!-- v-bind:class="[propertyName == '' ? activeClass : '', errorClass]" -->
                  <div class="stat_single_icon m-0 mb-2 " v-bind:class="[propertyName == 'TB Pathway' ? 'tbBgColor' : 'tbiBgColor']"  style="color:#fff">
                    <div class="icon_title">
                      <h6 class="mt-2 text-center">{{propertyName}}</h6>
                    </div>
                  </div>
                    <div class="row no-gutters" v-show="showChartFlag">
                        <div class="col-lg-4" v-show="charts.name" v-for="(charts, idx) in value" :key="idx">
                            <!-- {{charts}} -->
                            <div class="card">
                                <div class="card-header">{{ charts.name }}</div>
                                <div class="card-body">
                                    <highcharts :options="charts.chartObject" />
                                    <div>
                                        <span style="font-size: 12px;">*N : {{charts.number}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!showChartFlag">
                        No data available for selected filter.
                    </div>
                </div>
            </div>
            No data available for selected filter.
        </div>
    </div>
</div>
</template>

<script>
import ApiServices from "../service/ApiServices";
import {
    _
} from "vue-underscore";
export default {
    name: "home",
    components: {},
    data() {
        return {
            userData: JSON.parse(sessionStorage.getItem("userData")),
            countryList: {},
            countryFlag: true,
            stateList: [],
            stateId: "",
            stateFlag: true,
            districtList: [],
            distId: "",
            distFlag: true,
            filterOrgid: "",
            showChartFlag: false,
            chartDataList: [],
            flowChartObjNew: [],
            flowChartObj: {
                contacts_sympotms_tb: "0",
                Contacts_with_symptoms_evaluated_for_TB: "0",
                household_contacts_with_tb: "0",
                diagosed_contacts_tb: "0",
                contacts_no_sympotms_tb: "0",
                contact_evaluted_itbi: "0",
                contact_eligible_ltbi_treatment_intiation: "0",
                eligible_contacts_intiated_ltbi_treatment: "0",
                contact_eligible_ltbi_treatment: "0",
                status: "success",
            },
            masterList: {},
        };
    },
    methods: {
        getflowChartData(param) {
            var d = new Date();
            var month = d.getMonth() + 1;
            var day = d.getDate();
            var toDate =
                d.getFullYear() +
                "-" +
                (("" + month).length < 2 ? "0" : "") +
                month +
                "-" +
                (("" + day).length < 2 ? "0" : "") +
                day;
            let instance = {
                orgid: param,
                programid: this.userData.programid,
                fromdate: "2019-01-01",
                todate: toDate,
            };
            this.$root.isLoading = true;
            ApiServices.RestPostCall("ltbi/dashboard/analysis", instance).then(
                (res) => {
                    this.$root.isLoading = false;
                    this.flowChartObj = res;
                }
            );
        },
        getflowChartDataNew(param) {
            var d = new Date();
            var month = d.getMonth() + 1;
            var day = d.getDate();
            var toDate =
                d.getFullYear() +
                "-" +
                (("" + month).length < 2 ? "0" : "") +
                month +
                "-" +
                (("" + day).length < 2 ? "0" : "") +
                day;
            let instance = {
                orgid: param,
                fromdate: "2019-01-01",
                todate: toDate,
            };
            this.$root.isLoading = true;
            ApiServices.RestPostCall(
                "ltbi/dashboard/analysis/indicator",
                instance
            ).then((res) => {
                this.$root.isLoading = false;
                this.flowChartObjNew = _.sortBy(res.data, ["indicatorid"]);
            });
        },
        getChartData(param) {
            let instance = {
                programid: "21140",
                orgid:"" ,
                programuid: "U1nNSk2geJh",
                orguid: "HRvE77FT8Gh",
                authparam:"Basic MTQ5NjI1Nl9wYUBwcmV2ZW50dGIub3JnOjEyMzQ1Ng==",
                fromdate:"2021-01-01",
                todate:"2022-08-03",
            };
            this.$root.isLoading = true;
            ApiServices.RestPostCall("dashboardIndicator/getchartdata", instance)
                .then((res) => {
                    // console.log(res);
                    // this.masterList = res.data
                    if (Object.keys(res.data).length == 0) {
                        this.showChartFlag = false;
                    } else {
                        this.showChartFlag = true;
                    }
                    let temp = {}
                    Object.keys(res.data).forEach((key) => {
                        // console.log(res.data[key])
                        res.data[key].map((el) => {
                            var category = [];
                            var data = [];
                            var n = 0
                            if (el.type == "bar") {
                                el.values.map((items) => {
                                    category.push(items.name);
                                    data.push(parseInt(items.count));
                                    n = n + parseInt(items.count)
                                });
                                el.chartObject = this.drawBarChart(
                                    "column",
                                    el.name,
                                    el.xaxis,
                                    el.yaxis,
                                    category,
                                    data
                                );
                                el['number'] = n
                                this.chartDataList.push(el);
                            }
                            if (el.type == "line") {
                                el.values.map((items) => {
                                    category.push(items.name);
                                    data.push(parseInt(items.count));
                                    n = n + parseInt(items.count)
                                });
                                el.chartObject = this.drawBarChart(
                                    el.type,
                                    el.name,
                                    el.xaxis,
                                    el.yaxis,
                                    category,
                                    data
                                );
                                el['number'] = n
                                this.chartDataList.push(el);
                            }
                            if (el.type == "pie") {
                                el.values.map((items) => {
                                    var temp = [];
                                    var temp2 = [];
                                    var tempObj = {};
                                    tempObj.name = items.name;
                                    tempObj.y = parseInt(items.count);
                                    n = n + parseInt(items.count)
                                    data.push(tempObj);
                                });
                                el.chartObject = this.drawBarChart(
                                    el.type,
                                    el.name,
                                    el.xaxis,
                                    el.yaxis,
                                    category,
                                    data
                                );
                                el['number'] = n
                                this.chartDataList.push(el);
                            }
                        });
                    });
                    temp['Registration'] = res.data['Registration']
                    temp['RISK ASSESSMENT AND REFERRAL'] = res.data['RISK ASSESSMENT AND REFERRAL']
                    temp['TB Pathway'] = [...(res.data['TB TESTING FORM']), ...(res.data['TB TREATMENT INITIATION FORM'])];
                    temp['TPT Pathway '] = [...(res.data['TB INFECTION TESTING FORM']), ...(res.data['TPT INITIATION FORM']),res.data['TPT Outcome'] ? res.data['TPT Outcome'] : {}];
                    this.masterList = temp
                    console.log(this.masterList)
                    this.$root.isLoading = false;
                })
                .catch((error) => {
                    this.$root.isLoading = false;
                    console.log(error);
                    // swal("Request Failed.");
                });
        },
        // Functions for filter
        getHierarchy(param) {
            this.$root.isLoading = true
            let instance = {
                'orgid': param
            }
            ApiServices.RestGetCall('organisationUnits/' + param + '?paging=false&fields=*,children[id,name]').then(res => {
                console.log(res,"orgdata")
                if (res.level == '2') {
                    this.countryList = res
                    // console.log(this.countryList, "country")
                    this.stateList = res.children
                    this.$root.isLoading = false
                }
                if (res.level == '3') {
                    this.countryFlag = false
                    // this.distId = JSON.stringify(res.id)
                    this.stateList.push(res.data)
                    this.districtList = res.children
                }
                if (res.level == '4') {
                    this.countryFlag = false
                    this.stateFlag = false
                    // this.distId = JSON.stringify(res.id)
                    this.districtList.push(res.data)
                }
                // if(res.data.level == '6'){
                //     this.countryFlag = false
                //     this.stateFlag = false
                //     this.distFlag = false
                // }
            }).catch(error => {
                this.$root.isLoading = false
                console.log(error);
                // swal("Request Failed.");
            });
        },
        provinceSelect(event) {
            let stateId = event.target.value;
            this.filterOrgid = stateId;
            let instance = {
                orgid: stateId,
            };
            ApiServices.RestPostCall(
                "rtmpro/component/org/hierarchydata",
                instance
            ).then((res) => {
                this.distId = "";
                this.districtList = res.data.nodes;
            });
            // Object.keys(this.stateList).forEach(key => {
            //     if (this.stateList[key].id == stateId) {
            //         this.districtList = this.stateList[key].nodes
            //     }
            // })
        },
        districtChange(event) {
            let distID = event.target.value;
            this.filterOrgid = distID;
            let instance = {
                orgid: distID,
            };
            ApiServices.RestPostCall(
                "rtmpro/component/org/hierarchydata",
                instance
            ).then((res) => {
                this.facilityList = res.data.nodes;
            });
            // console.log(this.districtList,distID)
            // Object.keys(this.districtList).forEach(key => {
            //     if (this.districtList[key].id == distID) {
            //         this.facilityList = this.districtList[key].nodes

            //     }
            // })
        },
        cityChange(event) {
            let cityID = event.target.value;
            this.filterOrgid = cityID;
        },
        triggerFilter() {
            console.log(this.filterOrgid, "orgid");
            if (this.filterOrgid == "") {
                this.filterOrgid = this.userData.orgid;
            }
            this.getChartData(this.filterOrgid);
            // this.getflowChartData(this.filterOrgid)
            //   this.getflowChartDataNew(this.filterOrgid);
        },
        // Filter function END
        drawBarChart(
            chartType,
            chartTitle,
            xAxisLabel,
            yAxisLabel,
            categoryData,
            seriesData
        ) {
            return {
                chart: {
                    height: (6 / 9) * 100 + "%",
                    type: chartType,
                },
                title: {
                    text: "",
                },
                xAxis: {
                    categories: categoryData,
                    title: {
                        text: xAxisLabel,
                    },
                    labels: {
                        rotation: 0,
                    },
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: yAxisLabel,
                        align: "high",
                    },
                    labels: {
                        overflow: "justify",
                    },
                },
                tooltip: {
                    valueSuffix: "",
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                        },
                    },
                },
                credits: {
                    enabled: false,
                },
                series: [{
                    name: chartTitle,
                    data: seriesData,
                }, ],
            };
        },
    },
    mounted() {
        let langLocal = JSON.parse(sessionStorage.getItem("langLocal"));
        for (let lang in langLocal) {
            console.log(lang, langLocal[lang]);
            this.$i18n.setLocaleMessage(lang, langLocal[lang]);
        }
        this.getHierarchy(this.userData.organisationUnits[0].id);
        this.getChartData(this.userData.organisationUnits[0].id);
        // this.getflowChartData(this.userData.orgid)
        // this.getflowChartDataNew(this.userData.orgid);
    },
};
</script>

<style scoped>
.content-grid .card .card-body {
    /* height: calc(50vh - 49px); */
}
</style>
